import { ISanityBlockContent, ISanityTypographyBlock } from '@rbi-ctg/menu';
import { ICartEntryAdapter } from 'state/loyalty/hooks/types';

// Matches the SanityBlockRenderer `content` prop so consumers can pass block
// messaging straight through without casting.
export type PromoMessageBlock = ISanityBlockContent[] | ISanityTypographyBlock[] | null;

export interface PromoMessageContent {
  name?: string | null;
  loyaltyEngineId?: string | null;
  promoMessage?: string | null;
  promoMessageBlock?: PromoMessageBlock;
  activatedPromoMessageBlock?: PromoMessageBlock;
}

export interface BestPromotionResult {
  promotionId?: string;
  mustActivate?: boolean | null;
  userActivatedAt?: string | null;
  content?: PromoMessageContent | null;
  // Refetches every active observer of the underlying query (parity with the
  // legacy refetchQueries({ include: [...] }) behavior), hiding Apollo/document
  // from consumers.
  refetchPromotion: () => Promise<void>;
}

export interface BestPromotionSourceArgs {
  // Whether THIS source is the active one. Both sources stay mounted for stable
  // hook order; the inactive one self-skips.
  enabled: boolean;
  loyaltyId?: string;
  loyaltyEnabled: boolean;
  loyaltyLoading: boolean;
  cartEntries?: ICartEntryAdapter[];
  storeId?: string | null;
  skipStoreDayPartHours?: boolean;
  onActivateResolved?: () => void;
}

// A promotion no longer needs an explicit activation prompt once it either does
// not require activation or has already been activated by the user.
export const shouldClearActivateParam = (
  promotion?: { mustActivate?: boolean | null; userActivatedAt?: string | null } | null
): boolean => Boolean(promotion && (!promotion.mustActivate || promotion.userActivatedAt));
